import { render, staticRenderFns } from "./BrothersFreight.vue?vue&type=template&id=da1a1ba8&scoped=true"
import script from "./BrothersFreight.vue?vue&type=script&lang=js"
export * from "./BrothersFreight.vue?vue&type=script&lang=js"
import style0 from "./BrothersFreight.vue?vue&type=style&index=0&id=da1a1ba8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da1a1ba8",
  null
  
)

export default component.exports